import React from 'react';

type Props = {
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  size?: number;
};

export const PlusIcon = (props: Props) => {
  const {
    className,
    color: colorFromProps,
    size: sizeFromProps,
    style: styleFromProps,
  } = props;
  const color = colorFromProps || '#fff';
  const size = sizeFromProps || 24;

  const style = {
    ...styleFromProps,
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      style={style}
    >
      <g fill="none" fillRule="evenodd">
        <mask id="a" fill="#fff">
          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" />
        </mask>

        <g fill={color} mask="url(#a)">
          <path d="M-40-36H60V64H-40z" />
        </g>
      </g>
    </svg>
  );
};
